import { Tab as MUITab } from "@mui/material";
import { withStyles } from "@mui/styles";
import { C_ON_SURFACE, C_OUTLINE_VARIANT, C_PRIMARY, C_PRIMARY_HOVER, C_SURFACE, C_WHITE } from "../icon/Colors";
import { FontSize, getFontStyle } from "../materialInput/Fonts";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";

// @ts-ignore
const Tab = withStyles(
  {
    root: {
      background: C_SURFACE,
      border: `1px solid ${C_OUTLINE_VARIANT}`,
      padding: "8px",
      minHeight: "40px",
      [`@media ${MEDIA_QUERY_MIN_DESKTOP_S}`]: {
        padding: "8px 16px",
      },
      color: C_ON_SURFACE,
      ...getFontStyle(FontSize.BodyLarge),
      fontWeight: "bold",
      textTransform: "none",
      letterSpacing: "normal",
      transition: "150ms background",
      "&:hover": {
        color: C_PRIMARY_HOVER,
      },
    },
    selected: {
      background: C_WHITE,
      color: C_PRIMARY,
      "&:hover": {
        color: C_PRIMARY_HOVER,
      },
    },
    fullWidth: {
      flex: "1 !important",
      width: "50% !important",
      maxWidth: "50% !important",
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { name: (MUITab as any).muiName },
)(MUITab);

export default Tab;
